/* eslint-disable */
// because legacy

import { gettext, modals, notifications } from '@bikemap/js/services'
import { defaultPost } from '@bikemap/js/utility'
import { InitPasswordField } from '@bikemap/js/integrations/authentication'

/**
 * TODO: Replace this context workaround by imports, when functions and constants are extracted into modules!
 */
let changeSubTab, activeSubTabs
export function initMergeAccountSettingsContext(context) {
    changeSubTab = context.changeSubTab,
    activeSubTabs = context.activeSubTabs
}

function handleMergeAccountConfirm(e, modal) {
    modal.setLoading()
    const form = document.getElementById('merge-accounts-form')
    const body = new FormData(form)
    body.append('confirmed', true)
    defaultPost(form.action, body)
        .then(res => mergeAccountsCallback(res.callback_params))
        .catch(res => notifications.error(res.statusText))
        .finally(() => {
            modal.setLoading(false)
            modals.close()
        })
}

function mergeAccountsCallback(data) {
    if (data.message) {
        notifications.show({
            title: data.title,
            icon: data.icon,
            message: data.message,
            type: data.message_type,
        })
        if (data.confirmed === true) {
            changeSubTab($('#merge-accounts-link'))
        }
    } else if (data.html) {
        activeSubTabs.settings.html(data.html)
        $('#merge-accounts-mail-sent-back').on('click', function () {
            changeSubTab($('#merge-accounts-link'))
        })
    } else if (data.authenticated) {
        const $elem = $('<a id="merge-accounts-link" href="' + data.authenticated + '"></a>')
        changeSubTab($elem)
    } else {
        modals.show('merge-accounts', {
            title: gettext('Merge Account'),
            // This is a personalized warning message:
            body: data.modal_content,
            buttons: [
                { content: gettext('Cancel'), action: 'close' },
                { content: gettext('Confirm'), style: 'danger', action: 'submit' },
            ],
            onSubmit: handleMergeAccountConfirm,
        })
    }
}

// This function is copy-pasted from user-profile.js
export function initMergeAccountsForm() {
    const passwordField = new InitPasswordField(document.getElementById('merge-accounts-form'))
    passwordField.required = false
    passwordField.render()
    const $form = $('#merge-accounts-form')
    const $connectedUsersLink = $('#merge-accounts-connected-users')
    const $mergeAccountsFormSubmitButton = $("[type='submit']", $form)
    const $mergeAccountsFormCancelButton = $('#merge-accounts-form-cancel', $form)
    $mergeAccountsFormSubmitButton.add($mergeAccountsFormCancelButton)
    $mergeAccountsFormCancelButton.on('click', function () {
        $mergeAccountsFormSubmitButton
            .prop('disabled', true)
            .addClass('loading-spinner')
        changeSubTab($('#merge-accounts-link'))
    })
    $connectedUsersLink.on('click', function (ev) {
        ev.preventDefault()
        $mergeAccountsFormSubmitButton
            .prop('disabled', true)
            .addClass('loading-spinner')
        changeSubTab($('#merge-accounts-link'))
    })
    $('#merge-accounts-form').on('submit', function (ev) {
        ev.preventDefault()
        $mergeAccountsFormSubmitButton
            .prop('disabled', true)
            .addClass('loading-spinner')
        const formData = $form.serialize()
        $.ajax({
            form: $form,
            url: $form.attr('action'),
            method: 'POST',
            data: formData,
            formSuccessCallback: mergeAccountsCallback,
            headers: { 'X-CSRFToken': $.outdoorish.readCookie('csrftoken') },
            complete: $.outdoorish.forms.handleAjaxFormErrors,
            busyElement: $mergeAccountsFormSubmitButton,
            busyClass: 'loading-spinner',
        })
    })
    $('[data-toggle="tooltip"]').tooltip()
}
